import { Callback1 } from '@deqo/foundation';
import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { Hangout } from '../Hangout';
import { HangoutLocation } from '../HangoutLocation';
import { HangoutUser } from '../HangoutUser';

export const useHangoutLocationObserver = (pathOrPattern: string) => {
    const { locations } = useResolve(Hangout);
    useObserver(locations);
    const target = locations.get(pathOrPattern) || locations.find(x => x.test(pathOrPattern));
    useObserver(target);
    return !!target ? getUsersInLocation(target) : [];
};

export type HangoutLocationObserverProps = {
    locationId: string,
    render: Callback1<JSX.Element, HangoutUser[]>,
};

export const HangoutLocationObserver = React.memo<HangoutLocationObserverProps>(props => {
    return props.render(useHangoutLocationObserver(props.locationId));
});

const getUsersInLocation = (location: HangoutLocation) =>
    Array.from(new Set(Array.from(location.clients).map(x => x.user)));
